import { useState } from 'react';
import api from '../../../../api/api';
import { NOTIFICATION_VARIANT } from '../../../../constants/types';
import { handleRequestHelper } from '../../../../utils/helpers';
import { useNotifications } from '../../../../Providers/NotificationsProvider/NotificationsProvider';

export const useDraggableRecommendationListItem = ({ list, getLists }) => {
  const { id } = list;
  const { showNotification } = useNotifications();
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAccept = async () => {
    await handleRequestHelper({
      endpoint: () => api.deleteRecommendationList(id),
      onSuccess: () => {
        showNotification(
          'Lista de recomendación eliminada correctamente',
          NOTIFICATION_VARIANT.SUCCESS
        );
        setOpenModal(false);
        getLists();
      },
      showNotification,
    });
  };

  const handleDeleteList = () => {
    setOpenModal(true);
  };

  return { openModal, handleCloseModal, handleAccept, handleDeleteList };
};
